/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { Idp } from '../models/Idp';

export class ListIdpsResponse {
  /**
  * List of Identity Providers.
  */
  'idps': Array<Idp>;
  /**
  * Total number of IDPs.
  */
  'totalCount': number;
  /**
  * Token to retrieve the next page of results.
  */
  'nextToken'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "idps",
      "baseName": "idps",
      "type": "Array<Idp>",
      "format": ""
    },
    {
      "name": "totalCount",
      "baseName": "totalCount",
      "type": "number",
      "format": ""
    },
    {
      "name": "nextToken",
      "baseName": "nextToken",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListIdpsResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

